import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ salao_nome: "", responsavel_nome: "", email: "", whatsapp: "", senha: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.senha.length < 6) return toast.error("Senha deve ter ao menos 6 caracteres");
    setLoading(true);
    try {
      await register({ ...form, email: form.email.trim().toLowerCase() });
      toast.success("Salão criado!");
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(errorMessage(err, "Falha no cadastro"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] px-4 py-10" data-testid="register-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <img src="/connect-icon.svg" alt="" className="h-8 w-8" />
          <div className="text-left">
            <p className="text-[10px] font-semibold tracking-widest leading-none salonup-logo-badge">SalonUp</p>
            <h1 className="text-2xl font-bold tracking-tight text-zinc-50 leading-tight">CONNECT</h1>
          </div>
        </div>
        <div className="bg-[#111113] border border-zinc-800 rounded-xl p-6">
          <h2 className="text-lg font-semibold text-zinc-50 mb-1">Cadastre seu salão</h2>
          <p className="text-xs text-zinc-500 mb-5">Teste grátis. Seus dados ficam só no seu salão.</p>
          <form onSubmit={submit} className="space-y-3">
            <div>
              <Label className="text-xs">Nome do salão</Label>
              <Input data-testid="reg-salao" value={form.salao_nome} onChange={update("salao_nome")} required className="h-9 text-sm" placeholder="Ex: Studio Beleza" />
            </div>
            <div>
              <Label className="text-xs">Seu nome</Label>
              <Input data-testid="reg-responsavel" value={form.responsavel_nome} onChange={update("responsavel_nome")} required className="h-9 text-sm" placeholder="Como podemos te chamar" />
            </div>
            <div>
              <Label className="text-xs">E-mail</Label>
              <Input data-testid="reg-email" type="email" value={form.email} onChange={update("email")} required className="h-9 text-sm" placeholder="voce@salao.com" />
            </div>
            <div>
              <Label className="text-xs">WhatsApp</Label>
              <Input data-testid="reg-whatsapp" value={form.whatsapp} onChange={update("whatsapp")} required className="h-9 text-sm" placeholder="(11) 99999-9999" />
            </div>
            <div>
              <Label className="text-xs">Senha (mínimo 6)</Label>
              <Input data-testid="reg-senha" type="password" value={form.senha} onChange={update("senha")} required className="h-9 text-sm" placeholder="••••••" />
            </div>
            <Button data-testid="reg-submit" type="submit" disabled={loading} className="w-full bg-amber-500 text-zinc-950 hover:bg-amber-600 h-9 text-sm font-semibold mt-2">
              {loading ? "Criando..." : "Criar conta"}
            </Button>
          </form>
          <p className="text-xs text-zinc-500 mt-5 text-center">
            Já tem conta? <Link to="/login" className="text-amber-400 hover:text-amber-300" data-testid="link-login">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
